<template>
  <div>
    <div class="title">{{ title }}</div>
    
    <slick-assets
        :obj-user-setting.sync="getUserSetting"
        @callback-func="onCallBack"
    ></slick-assets>
  </div>
</template>

<script>
import { mapGetters , mapActions } from "vuex"
import { SlickAssets } from "../../../components/molecules"
export default {
    components: {
        SlickAssets
    },
    data() {
      return {
        sortAssets: null
      }
    },
    activated() {
      this.sortAssets = this.getUserSetting.assets
    },
    computed: {
        ...mapGetters("onboarding", ["getUserSetting"]),
        title: function() {
          const en = "Sort Investment Assets"
          const th = "เรียงลำดับความสนใจการลงทุน"

          if (this.getUserSetting.language === "TH") return th 
          return en
        }
    },
    methods: {
      ...mapActions("onboarding", ["insertConfiguration"]),
      onCallBack(obj) {
        const { val, type } = obj
        this.getUserSetting.assets = val
      },
    },
     deactivated() {
        if(JSON.stringify(this.sortAssets) !== JSON.stringify(this.getUserSetting.assets)) {
          this.insertConfiguration()
        }
    },
}
</script>

<style lang="scss" scoped>
  .title {
    @extend %font-size-m;
    padding: 18px;
    font-weight: bold;
  }

  ::v-deep .slick__item {
    &:first-child {
      border-top: 1px solid var(--color-outline)!important;
    }
    border-top: 1px!important;
    margin: 0!important;
    height: 56px!important;
    border-radius: 0!important;
  }

  ::v-deep .name {
    font-weight: normal!important;
  }
</style>